// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeViewItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;

  var observer = require('mobx-react').observer;
  var classnames = require('classnames');

  var TreeViewItem = React.createClass({
    propTypes : {
      node: ObservablePropTypes.objectOrObservableObject,
      renderNode: PropTypes.func.isRequired,
      toggleCollapsible: PropTypes.func.isRequired,
      expanded : PropTypes.bool
    },
    shouldComponentUpdate : function (nextProps) {
      return (nextProps.expanded !== this.props.expanded)
        || (nextProps.node !== this.props.node);
    },
    render : function () {
      var props = this.props;
      var node = props.node;
      var renderNode = props.renderNode;
      var hasChild = node.childCount;
      var toggleIcon = hasChild ? this.renderToggleIcon() : null;
      var isCollapsed = !props.expanded;
      var level = node.level;
      var className = classnames('izenda-TreeViewItem', props.treeViewItemClassName);

      return (
        <div className={className} style={{paddingLeft: 20*level}}>
          {renderNode(node.data, toggleIcon, this.toggle, isCollapsed, node.parent)}
        </div>
      )
    },
    renderToggleIcon : function () {
      var expanded = this.props.expanded;
      var className = classnames('u_curPointer icon-arrow', {
        'expanded' : expanded
      });
      return (
        <i
          className={className}
          onClick={this.toggle}/>
      );
    },
    toggle : function () {
      var props = this.props;
      var node = props.node;
      var toggleCollapsible = props.toggleCollapsible;
      toggleCollapsible(node);
    }
  });

  module.exports = observer(TreeViewItem);

}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/TreeView/Izenda.TreeViewItem.jsx